import { PageHero } from '@/components/ui/PageHero'
import { herbalWalkOne } from '@/assets/siteMedia'

export const TrainingHero = () => (
  <PageHero
    image={herbalWalkOne}
    imageAlt="Kandake with a group sitting together in a community garden"
    highlights={['Courses & workshops', 'Herbal walks', 'Community education']}
    title="Learn from"
    accent="two decades of practice."
    description={
      <p>Upcoming workshops, seminars, and professional training events by Kandake Makonnen.</p>
    }
  />
)
